
export class SuccessModal {
  static show(VueComponent, text, closedFn = () => null) {
    VueComponent.$modal.show({
      template: `
            <div class="alert alert-success" style="margin: 0;">
                <button v-on:click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
                <p>{{ text }}</p>
            </div>`,
      props: ['text']
    }, {
      text: text
    }, {
      name: 'SuccessModal',
      height: 'auto',
      adaptive: true,
    }, {
      'closed': (event) => closedFn(event)
    })
  }
}
